import { useState } from 'react'
import './Tags.css'

const Tags = () => {
  const [tags, setTags] = useState([])

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1>NAH44 Tags</h1>
          <p className="page-subtitle">Generate and manage QR codes for your vehicles</p>
        </div>
        <button className="btn-primary">+ Create New Tag</button>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Your Tags</h2>
        </div>
        {tags.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">🏷️</div>
            <p>No tags created yet</p>
            <p className="empty-state-subtitle">Create your first vehicle tag to get started</p>
            <button className="btn-primary mt-4">Create Your First Tag</button>
          </div>
        ) : (
          <div className="tags-grid">
            {/* Tags will be displayed here */}
          </div>
        )}
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="card-title">How It Works</h2>
        </div>
        <div className="info-grid">
          <div className="info-card">
            <div className="info-icon">1️⃣</div>
            <h3>Create a Tag</h3>
            <p>Generate a unique QR code for your vehicle</p>
          </div>
          <div className="info-card">
            <div className="info-icon">2️⃣</div>
            <h3>Print & Display</h3>
            <p>Print the QR code and display it on your vehicle</p>
          </div>
          <div className="info-card">
            <div className="info-icon">3️⃣</div>
            <h3>Privacy First</h3>
            <p>Contact vehicle owners while maintaining privacy</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tags


